
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
//import "./ViewAllCommon.scss"
import { useHistory, useParams } from "react-router"
import { useSelector } from "react-redux"
import EditFormsAndTemplatesV2 from './EditFormsAndTemplatesV2'
import React, { useState, useEffect } from "react"
import { getFormTemplateById } from "core/services/api"
import ReadAndWriteTable from "./ReadAndWriteAccess/ReadAndWriteTable"
import ConsentMapping from "./ConsentMapping/ConsentMapping"
import { useLocation } from "react-router-dom"



function FormEditorMenu() {
  interface TabPanelProps {
    children?: React.ReactNode
    index: number
    value: number
  }
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    }
  }

  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }
  const history = useHistory()
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail);
  const [formTemplate, setFormTemplate] = useState<any>()
  const location = useLocation()
  const { id } = useParams<{ id: string }>()
  useEffect(() => {

    getFormTemplateById(id)
      .then((res: any) => {
        setFormTemplate(res)

      })
      .catch((err: any) => {
        console.log(err, "error")

      })
  }, [id])


  return (
    <>
      <div style={{ display: 'flex' }}>
        <div
          className="approval-back-image"
          onClick={() => {
            //history.goBack()
            history.push({
              pathname: `/forms-v2`,
              state: { consentType: location.state.consentType, previousPath: "editConsent" }
            })
          }}
        >
          <img
            src="../../assets/images/back-icon.svg"
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"

          />
        </div>
        <div className='pending-request-heading'>Edit Form Template</div>
      </div>




      {/* 
      <Box sx={{ width: "100%", marginTop: "20px" }}>
        <Box sx={{}}>
          <Tabs
            TabIndicatorProps={{
              sx: {
                bgcolor: "blue",
                height: "2px",
                color: "blue",
              },
            }}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >

            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Form Details"
              {...a11yProps(0)}
            />
            {formTemplate?.type !== "CANCER" && (
              <Tab
                sx={{
                  textTransform: "none",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
                label="Permission"
                {...a11yProps(1)}
              />
            )}
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Consent Mapping"
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <EditFormsAndTemplatesV2 />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ReadAndWriteTable
            formTemplate={formTemplate}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ConsentMapping
            formTemplate={formTemplate}
          />
        </TabPanel>
      </Box> */}
      <Box sx={{ width: "100%", marginTop: "20px" }}>
        <Box sx={{}}>
          <Tabs
            TabIndicatorProps={{
              sx: {
                bgcolor: "blue",
                height: "2px",
                color: "blue",
              },
            }}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Form Details"
              {...a11yProps(0)}
            />
            {formTemplate?.type !== "COMMON" && formTemplate?.type !== "CANCER" && (
              <Tab
                sx={{
                  textTransform: "none",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
                label="Permission"
                {...a11yProps(1)}
              />
            )}
            {formTemplate?.type !== "COMMON" && formTemplate?.type !== "CANCER" && (
              <Tab
                sx={{
                  textTransform: "none",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
                label="Consent Mapping"
                {...a11yProps(1)}
              />
            )}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <EditFormsAndTemplatesV2 formTemplate={formTemplate} />
        </TabPanel>
        {(formTemplate?.type !== "COMMON" && formTemplate?.type !== "CANCER") && (
          <TabPanel value={value} index={1}>
            <ReadAndWriteTable
              formTemplate={formTemplate}
            />
          </TabPanel>
        )}
        {(formTemplate?.type !== "COMMON" && formTemplate?.type !== "CANCER") && (
          <TabPanel value={value} index={2}>
            <ConsentMapping
              formTemplate={formTemplate}
            />
          </TabPanel>
        )}
      </Box>


    </>

  )
}

export default FormEditorMenu